import image_0000 from "../assets/sequence/0000.png";
import image_0001 from "../assets/sequence/0001.png";
import image_0002 from "../assets/sequence/0002.png";
import image_0003 from "../assets/sequence/0003.png";
import image_0004 from "../assets/sequence/0004.png";
import image_0005 from "../assets/sequence/0005.png";
import image_0006 from "../assets/sequence/0006.png";
import image_0007 from "../assets/sequence/0007.png";
import image_0008 from "../assets/sequence/0008.png";
import image_0009 from "../assets/sequence/0009.png";
import image_0010 from "../assets/sequence/0010.png";
import image_0011 from "../assets/sequence/0011.png";
import image_0012 from "../assets/sequence/0012.png";
import image_0013 from "../assets/sequence/0013.png";
import image_0014 from "../assets/sequence/0014.png";
import image_0015 from "../assets/sequence/0015.png";
import image_0016 from "../assets/sequence/0016.png";
import image_0017 from "../assets/sequence/0017.png";
import image_0018 from "../assets/sequence/0018.png";
import image_0019 from "../assets/sequence/0019.png";
import image_0020 from "../assets/sequence/0020.png";
import image_0021 from "../assets/sequence/0021.png";
import image_0022 from "../assets/sequence/0022.png";
import image_0023 from "../assets/sequence/0023.png";
import image_0024 from "../assets/sequence/0024.png";
import image_0025 from "../assets/sequence/0025.png";
import image_0026 from "../assets/sequence/0026.png";
import image_0027 from "../assets/sequence/0027.png";
import image_0028 from "../assets/sequence/0028.png";
import image_0029 from "../assets/sequence/0029.png";
import image_0030 from "../assets/sequence/0030.png";
import image_0031 from "../assets/sequence/0031.png";
import image_0032 from "../assets/sequence/0032.png";
import image_0033 from "../assets/sequence/0033.png";
import image_0034 from "../assets/sequence/0034.png";
import image_0035 from "../assets/sequence/0035.png";
import image_0036 from "../assets/sequence/0036.png";
import image_0037 from "../assets/sequence/0037.png";
import image_0038 from "../assets/sequence/0038.png";
import image_0039 from "../assets/sequence/0039.png";
import image_0040 from "../assets/sequence/0040.png";
import image_0041 from "../assets/sequence/0041.png";
import image_0042 from "../assets/sequence/0042.png";
import image_0043 from "../assets/sequence/0043.png";
import image_0044 from "../assets/sequence/0044.png";
import image_0045 from "../assets/sequence/0045.png";
import image_0046 from "../assets/sequence/0046.png";
import image_0047 from "../assets/sequence/0047.png";
import image_0048 from "../assets/sequence/0048.png";
import image_0049 from "../assets/sequence/0049.png";
import image_0050 from "../assets/sequence/0050.png";
import image_0051 from "../assets/sequence/0051.png";
import image_0052 from "../assets/sequence/0052.png";
import image_0053 from "../assets/sequence/0053.png";
import image_0054 from "../assets/sequence/0054.png";
import image_0055 from "../assets/sequence/0055.png";
import image_0056 from "../assets/sequence/0056.png";
import image_0057 from "../assets/sequence/0057.png";
import image_0058 from "../assets/sequence/0058.png";
import image_0059 from "../assets/sequence/0059.png";
import image_0060 from "../assets/sequence/0060.png";
import image_0061 from "../assets/sequence/0061.png";
import image_0062 from "../assets/sequence/0062.png";
import image_0063 from "../assets/sequence/0063.png";
import image_0064 from "../assets/sequence/0064.png";
import image_0065 from "../assets/sequence/0065.png";
import image_0066 from "../assets/sequence/0066.png";
import image_0067 from "../assets/sequence/0067.png";
import image_0068 from "../assets/sequence/0068.png";
import image_0069 from "../assets/sequence/0069.png";
import image_0070 from "../assets/sequence/0070.png";

export const iphone_images = [
  image_0000,
  image_0001,
  image_0002,
  image_0003,
  image_0004,
  image_0005,
  image_0006,
  image_0007,
  image_0008,
  image_0009,
  image_0010,
  image_0011,
  image_0012,
  image_0013,
  image_0014,
  image_0015,
  image_0016,
  image_0017,
  image_0018,
  image_0019,
  image_0020,
  image_0021,
  image_0022,
  image_0023,
  image_0024,
  image_0025,
  image_0026,
  image_0027,
  image_0028,
  image_0029,
  image_0030,
  image_0031,
  image_0032,
  image_0033,
  image_0034,
  image_0035,
  image_0036,
  image_0037,
  image_0038,
  image_0039,
  image_0040,
  image_0041,
  image_0042,
  image_0043,
  image_0044,
  image_0045,
  image_0046,
  image_0047,
  image_0048,
  image_0049,
  image_0050,
  image_0051,
  image_0052,
  image_0053,
  image_0054,
  image_0055,
  image_0056,
  image_0057,
  image_0058,
  image_0059,
  image_0060,
  image_0061,
  image_0062,
  image_0063,
  image_0064,
  image_0065,
  image_0066,
  image_0067,
  image_0068,
  image_0069,
  image_0070,
];
